import './ComingSoonPopup.css';

export default function ComingSoonPopup({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <h2>Coming Soon</h2>
        <p>This feature is still being developed.</p>
        <button className="popup-btn" onClick={onClose}>Okay</button>
      </div>
    </div>
  );
}
